import type { StreamAiCreditDenied } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { notifyAgentRunStateForConversation } from '@atlassian/conversation-assistant-store/controllers/agent-mention-run-state';
import type {
	ChatStorePrivateState,
	Conversation,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { clearAnswerNowStatusForMessageIfSet } from './clearAnswerNowStatusForMessageIfSet';
import { clearTracesIfNotEmpty } from './clearTracesIfNotEmpty';
import { processCreditDenial } from './processCreditDenial';
import type { ChatStoreContainerProps } from './types';

type HandleCreditDenialOptions = {
	conversationId: string;
	assistantMessageId: string;
	streamMessage: StreamAiCreditDenied;
	getState: () => ChatStorePrivateState;
	getMessages: ChatStoreContainerProps['getMessages'];
	setMessages: ChatStoreContainerProps['setMessages'];
	updateCurrentConversation: (data: Partial<Conversation>) => void;
	reportCreditDenial: ChatStoreContainerProps['reportCreditDenial'];
	sendAnalyticsEvent: ChatStoreContainerProps['sendAnalyticsEvent'];
};

export const handleCreditDenial = ({
	conversationId,
	assistantMessageId,
	streamMessage,
	getState,
	getMessages,
	setMessages,
	updateCurrentConversation,
	reportCreditDenial,
	sendAnalyticsEvent,
}: HandleCreditDenialOptions): void => {
	reportCreditDenial?.(streamMessage.denial);
	clearTracesIfNotEmpty(getState, conversationId, updateCurrentConversation);
	clearAnswerNowStatusForMessageIfSet(conversationId, assistantMessageId, getMessages, setMessages);
	const result = processCreditDenial({
		messages: getMessages(conversationId),
		streamMessage,
		assistantMessageId,
	});
	setMessages(conversationId, result.messages);
	sendAnalyticsEvent({
		eventType: 'track',
		action: 'received',
		actionSubject: 'aiCreditDenied',
		attributes: {
			scope: result.creditDenial.denial.scope,
			hasResetDate: result.creditDenial.denial.resetsAt != null,
			hasRequestMethod: result.creditDenial.denial.requestMethod != null,
			isDuplicate: result.isDuplicate,
		},
	});
	notifyAgentRunStateForConversation(conversationId, 'blocked');
};
